import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { first, Subject } from 'rxjs';
import { ControlService } from 'src/app/services/control.service';
import { DeviceService } from 'src/app/services/device.service';
import { ScalingService } from 'src/app/services/scaling.service';
import { VendorUtilService } from 'src/app/services/vendor-util.service';
import { ImagePool } from './image-pool';
import { VideoService } from 'src/app/services/video.service';
import { takeUntil } from 'rxjs/operators';
import * as pako from 'pako';
import { FullViewComponent } from '../../full-view/full-view.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-device-screen',
  templateUrl: './device-screen.component.html',
  styleUrls: ['./device-screen.component.css'],
  standalone: true,
  imports: [FullViewComponent, TranslateModule, CommonModule, FormsModule]
})
export class DeviceScreenComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  private unsubscribe$ = new Subject<void>();
  @ViewChild('canvas', { static: false }) canvasRef!: ElementRef<HTMLCanvasElement>;
  @ViewChild('positioner') positioner: ElementRef;
  private canvaslisteners: (() => void)[] = [];
  private mediaRecorder!: MediaRecorder;
  private recordedChunks: Blob[] = [];
  isAnimating = false;
  animationFrameId = null;
  videoUrl: string | null = null;
  @ViewChild('tooltipElement') tooltipElement: ElementRef;
  @Input() showScreen: boolean;
  @Input() control: ControlService;
  @Input() device: any;
  @Input() fullViewDevice: boolean;
  @Input() deviceScreen: boolean;
  @Input() showCoordinates: boolean;
  @Output() cursorState = new EventEmitter<string>();
  @Output() fullViewState = new EventEmitter<boolean>();
  private listeners: { [key: string]: EventListener } = {};
  firstTimeControl: boolean = true;
  prevCoords: { x?: number; y?: number } = {};
  displayError: any;
  screen: any;
  element: HTMLElement;
  loader: boolean = true;
  URL: any;
  BLANK_IMG: any;
  cssTransform: any;
  isScreenRotated: boolean = false;
  input: HTMLInputElement;
  scaler: any;
  ws: WebSocket;
  cursor: string = 'wait';
  canvasAspect: number;
  private destroyFunctions: Function[] = [];

  // FPS monitoring variables
  private frameCount = 0;
  private lastFrameTime = 0;
  private frameTimeHistory: number[] = [];
  private currentFPS = 0;
  private lowFPSStartTime = 0;
  private isLowFPSAlertActive = false;
  private lastAlertTime = 0;
  private readonly MIN_FPS_THRESHOLD = 10; // Minimum 10 FPS threshold to trigger alert
  private readonly LOW_FPS_DURATION_THRESHOLD = 6000;
  private readonly ALERT_COOLDOWN = 10000;
  private readonly FRAME_HISTORY_SIZE = 30;

  mapping = {
    0: {
      0: 0
      , 90: -90
      , 180: -180
      , 270: 90
    }
    , 90: {
      0: 90
      , 90: 0
      , 180: -90
      , 270: 180
    }
    , 180: {
      0: 180
      , 90: 90
      , 180: 0
      , 270: -90
    }
    , 270: {
      0: -90
      , 90: -180
      , 180: 90
      , 270: 0
    }
  }
  receivedValue: boolean;
  recordinngDate: string;
  abscissa: number = 0;
  ordinate: number = 0;


  constructor(
    private vendorUtilService: VendorUtilService,
    private scalingService: ScalingService,
    private elementRef: ElementRef,
    private deviceService: DeviceService,
    private renderer: Renderer2,
    private controlService: ControlService,
    private videoService: VideoService
  ) {
  }

  ngOnInit(): void {
    window.onbeforeunload = null;
    this.recordedChunks = []
    this.recordedChunks = null
    // ios change
    // let attempts = parseInt(localStorage.getItem(`attempts-${this.device.serial}`)) || 0;

    //   if (this.device.plaform=="iOS" && this.device.present && (!this.device.display.width || !this.device.display.height) && attempts < 3) {
    //     attempts++;
    //     localStorage.setItem(`attempts-${this.device.serial}`, attempts);
    //     return Promise.setTimeout(() => {
    //       window.location.reload()
    //     },1000)
    //   }

    //   localStorage.removeItem(`attempts-${$scope.device.serial}`)

    // ios change
    // const context = this.canvasRef.nativeElement.getContext('2d');
    // context.fillStyle = 'lightblue';
    // context.fillRect(10, 10, 150, 100); // Example drawing


    // setTimeout(() => {
    //   this.stop()
    // }, 20000);

    this.videoService.Pause.subscribe((value => {
      if (value === true) {
        this.pauseRecording();
      }
    }))

    this.videoService.Resume.subscribe((value) => {
      if (value === true) {
        this.resumeRecording();
      }
    })
    this.videoService.boolean$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(value => {
        if (value === true) {
          this.startRecording();
        } else {
          this.stopRecording();
        }
      });
    this.URL = window.URL || window.webkitURL;
    this.BLANK_IMG = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    this.cssTransform = this.vendorUtilService.style(['transform', 'webkitTransform']);
    this.isScreenRotated = false;
    this.element = this.elementRef.nativeElement;
    this.input = this.element.querySelector('input');
    // this.input = this.elementRef.nativeElement.find('input');
    this.displayError = false;

    this.screen = {
      rotation: 0
      , bounds: {
        x: 0
        , y: 0
        , w: 0
        , h: 0
      }
    };

    this.scaler = this.scalingService.coordinator(
      this.device.display.width
      , this.device.display.height
    );
  }

  ngAfterViewInit() {
    this.methodOne();
    this.keyboardHandlingMethod();
    this.touchHandlingMethod();
    // Add wheel event listener to the canvas for two-finger touchpad gestures
    const wheelListener = this.renderer.listen(
      this.positioner.nativeElement,
      'wheel',
      (event: WheelEvent) => {
        // For touchpads, we need to rely on other properties to detect multi-finger gestures
        // ctrlKey is often set for pinch-zoom which is a common two-finger gesture
        // or check if deltaX exists (horizontal scrolling often indicates two fingers)
        if (Math.abs(event.deltaX) > 0) {
          //swipe sideways
          // Prevent default scrolling behavior if needed
          // event.preventDefault();

          // Detect direction based on deltaX value
          if (event.deltaX > 0) {
            //swipe rightwards
            this.control.shell(`input swipe 500 800 ${500 - Math.abs(event.deltaX)} 800`);
          } else {
            //swipe leftwards
            this.control.shell(`input swipe 500 800 ${500 + Math.abs(event.deltaX)} 800`);
          }
        } else {
          //swipe sideways
          // Prevent default scrolling behavior if needed
          // event.preventDefault();

          // Detect direction based on deltaX value
          if (event.deltaY > 0) {
            //swipe upwards
            this.control.shell(`input swipe 500 800 500 ${800 - Math.abs(event.deltaY)}`);
          } else {
            //swipe downwards
            this.control.shell(`input swipe 500 800 500 ${800 + Math.abs(event.deltaY)}`);
          }
        }
      }
    );

    // Store the listener removal function
    this.canvaslisteners.push(wheelListener);
    this.sendCursorStateToDeviceControl();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.showScreen == false)
      this.loader = true;
    //for full-view
    if (this.fullViewDevice) {
      console.log('1st if:this.fullViewDevice in device-screen is ', this.fullViewDevice, '\nthis.firstTimeControl is ', this.firstTimeControl);
      //put a delay to ensure the device is not kicked before acquiring the new connection in full-view
      // setTimeout(() => {
      this.ws.close();
      this.removeListeners();
      // }, 5000);
    }
    else if (!this.firstTimeControl) {
      this.methodOne();
      this.touchHandlingMethod();
    }
  }

  updateTooltipPosition(event: any) {
    if (this.tooltipElement) {
      const tooltip = this.tooltipElement.nativeElement;
      // Position the tooltip near the cursor
      tooltip.style.left = `${event.layerX}px`;
      tooltip.style.top = `${event.layerY}px`;
    }
  }

  animateCanvas() {
    // Redraw your canvas content here
    // For example:
    // const ctx = this.canvasRef.nativeElement.getContext('2d');
    // Your drawing code here...

    // Continue the animation loop
    this.animationFrameId = requestAnimationFrame(this.animateCanvas);
  }

  ensureRendering() {
    if (!this.isAnimating) {
      this.isAnimating = true;
      this.animateCanvas();
    }
  }

  // Canvas animation loop

  removeListeners() {
    this.destroyFunctions.forEach(destroyFn => destroyFn());
    this.input.removeEventListener('keydown', this.listeners['keydown']);
    this.input.removeEventListener('keyup', this.listeners['keyup']);
    this.input.removeEventListener('input', this.listeners['input']);
    this.input.removeEventListener('paste', this.listeners['paste']);
    this.input.removeEventListener('copy', this.listeners['copy']);
    this.destroyFunctions = [];
  }

  sendCursorStateToDeviceControl() {
    this.cursorState.emit(this.cursor);
  }

  sendfullViewStatetoControl() {
    this.fullViewState.emit(false);
  }

  handlefullView(data: boolean) {
    this.fullViewDevice = data;
    this.firstTimeControl = false;
    this.sendfullViewStatetoControl();
  }

  stop() {
    try {
      this.ws.onerror = this.ws.onclose = this.ws.onmessage = this.ws.onopen = null;
      this.ws.close();
      this.ws = null;
    }
    catch (err) { /* noop */ }
  }

  rotator(oldRotation: any, newRotation: any) {
    let r1 = oldRotation < 0 ? 360 + oldRotation % 360 : oldRotation % 360
    let r2 = newRotation < 0 ? 360 + newRotation % 360 : newRotation % 360

    return this.mapping[r1][r2];
  }

  methodOne() {
    let _global = this;

    // ios change
    if (this.device.ios) {
      // take url if available or else fetch it from display.url for IOS
      if (this.device?.url)
        this.ws = new WebSocket(this.device.url);
      else this.ws = new WebSocket(this.device.display.url);
    }
    else {
      this.ws = new WebSocket(this.device.display.url);
    }
    // ios change
    this.ws.binaryType = 'blob';


    let adjustedBoundSize: any;
    let cachedEnabled = false;

    let canvas = this.element.querySelector('canvas');
    //let canvas = this.element.find('canvas')[0]
    //let mobile_wrapper=element.find('img')[0]
    let g = canvas.getContext('2d');
    // canvas.captureStream(30)



    let positioner = this.element.querySelector('div');


    this.deviceService.updateOwnerInfo(this.device.serial, this.device.owner).pipe(first()).subscribe();

    let devicePixelRatio = window.devicePixelRatio || 1;
    let backingStoreRatio = vendorBackingStorePixelRatio(g);
    let frontBackRatio = devicePixelRatio / backingStoreRatio;

    let options = {
      autoScaleForRetina: true
      , density: Math.max(1, Math.min(1.5, devicePixelRatio || 1))
      , minscale: 0.36
    }

    // FPS calculation function
    const calculateFPS = (): number => {
      if (this.frameTimeHistory.length < 2) return 0;
      const totalTime = this.frameTimeHistory.reduce((sum, interval) => sum + interval, 0);
      const avgInterval = totalTime / this.frameTimeHistory.length;
      return avgInterval > 0 ? Math.round(1000 / avgInterval) : 0;
    }

    // FPS monitoring function
    // const monitorFPS = () => {
    //   const now = performance.now();
    //   this.currentFPS = calculateFPS();

    //   if (_global.device.using && _global.ws.readyState === WebSocket.OPEN && this.currentFPS > 0) {
    //     if (this.currentFPS < this.MIN_FPS_THRESHOLD) {
    //       if (this.lowFPSStartTime === 0) {
    //         this.lowFPSStartTime = now;
    //       } else if (now - this.lowFPSStartTime >= this.LOW_FPS_DURATION_THRESHOLD) {
    //         if (!this.isLowFPSAlertActive && (now - this.lastAlertTime) >= this.ALERT_COOLDOWN) {
    //           this.triggerLowFPSAlert();
    //           this.lastAlertTime = now;
    //           this.isLowFPSAlertActive = true;
    //         }
    //       }
    //     } else {
    //       this.lowFPSStartTime = 0;
    //       if (this.isLowFPSAlertActive) {
    //         this.isLowFPSAlertActive = false;
    //       }
    //     }
    //   }
    // }

    // Function to trigger low FPS alert (implement your alert logic here)
    // const triggerLowFPSAlert = () => {
    //   this.showLowFPSToast();
    // }

    // Reset FPS monitoring when connection changes
    const resetFPSMonitoring = () => {
      this.frameCount = 0;
      this.lastFrameTime = 0;
      this.frameTimeHistory = [];
      this.currentFPS = 0;
      this.lowFPSStartTime = 0;
      this.isLowFPSAlertActive = false;
    }



    this.ws.onerror = function errorListener() {
      resetFPSMonitoring();
      // @todo Handle
    }

    this.ws.onclose = function closeListener() {
      resetFPSMonitoring();
      // @todo Maybe handle
      _global.ws = null;
    }

    this.ws.onopen = function openListener() {
      resetFPSMonitoring();
      checkEnabled()
    }

    function vendorBackingStorePixelRatio(g: any) {
      return g.webkitBackingStorePixelRatio ||
        g.mozBackingStorePixelRatio ||
        g.msBackingStorePixelRatio ||
        g.oBackingStorePixelRatio ||
        g.backingStorePixelRatio || 1
    }

    function updateBounds() {
      function adjustBoundedSize(w: any, h: any) {
        let sw = w * options.density
        let sh = h * options.density
        let f

        if (sw < (f = _global.device.display.width * options.minscale)) {
          sw *= f / sw
          sh *= f / sh
        }

        if (sh < (f = _global.device.display.height * options.minscale)) {
          sw *= f / sw
          sh *= f / sh
        }

        return {
          w: Math.ceil(sw)
          , h: Math.ceil(sh)
        }
      }

      let w = _global.screen.bounds.w = (_global.element.firstElementChild as HTMLElement).offsetWidth;
      let h = _global.screen.bounds.h = (_global.element.firstElementChild as HTMLElement).offsetHeight;
      // Developer error, let's try to reduce debug time
      if (!w || !h) {
        throw new Error(
          'Unable to read bounds; container must have dimensions'
        )
      }

      let newAdjustedBoundSize = (() => {
        switch (_global.screen.rotation) {
          case 90:
          case 270:
            return adjustBoundedSize(h, w)
          case 0:
          case 180:
          /* falls through */
          default:
            return adjustBoundedSize(w, h)
        }
      })()

      if (!adjustedBoundSize ||
        newAdjustedBoundSize.w !== adjustedBoundSize.w ||
        newAdjustedBoundSize.h !== adjustedBoundSize.h) {
        adjustedBoundSize = newAdjustedBoundSize
        onScreenInterestAreaChanged();
      }
    }

    function shouldUpdateScreen() {
      return (
        // NO if the user has disabled the screen.
        // scope.$parent.showScreen &&
        // NO if we're not even using the device anymore.
        _global.device.using &&
        // NO if the page is not visible (e.g. background tab).
        // !PageVisibilityService.hidden &&  <-------------------------- check this
        // NO if we don't have a connection yet.
        _global.ws.readyState === WebSocket.OPEN
        // YES otherwise
      )
    }

    function checkEnabled() {
      let newEnabled = shouldUpdateScreen()
      if (newEnabled === cachedEnabled) {
        updateBounds()
      }
      else if (newEnabled) {
        updateBounds()
        onScreenInterestGained()
      }
      else {
        g.clearRect(0, 0, canvas.width, canvas.height)
        onScreenInterestLost()
        resetFPSMonitoring(); // Reset FPS monitoring when screen interest is lost
      }

      cachedEnabled = newEnabled
    }

    function onScreenInterestGained() {
      if (_global.ws.readyState === WebSocket.OPEN) {
        _global.ws.send('size ' + adjustedBoundSize.w + 'x' + adjustedBoundSize.h)
        _global.ws.send('on')
        resetFPSMonitoring(); // Reset FPS monitoring when screen interest is lost
      }
    }

    function onScreenInterestAreaChanged() {
      if (_global.ws.readyState === WebSocket.OPEN) {
        _global.ws.send('size ' + adjustedBoundSize.w + 'x' + adjustedBoundSize.h)
      }
    }

    function onScreenInterestLost() {
      if (_global.ws.readyState === WebSocket.OPEN) {
        _global.ws.send('off')
      }
    }

    this.ws.onmessage = (() => {

      let cachedScreen = {
        rotation: 0
        , bounds: {
          x: 0
          , y: 0
          , w: 0
          , h: 0
        }
      }

      let cachedImageWidth = 0;
      let cachedImageHeight = 0;
      let cssRotation = 0;
      let alwaysUpright = false;
      let imagePool = new ImagePool(10);

      function applyQuirks(banner: any) {
        _global.element.classList.toggle(
          'quirk-always-upright', alwaysUpright = banner.quirks.alwaysUpright)
      }

      function hasImageAreaChanged(img: any) {
        return cachedScreen.bounds.w !== _global.screen.bounds.w ||
          cachedScreen.bounds.h !== _global.screen.bounds.h ||
          cachedImageWidth !== img.width ||
          cachedImageHeight !== img.height ||
          cachedScreen.rotation !== _global.screen.rotation
      }

      function isRotated() {
        return _global.screen.rotation === 90 || _global.screen.rotation === 270;
      }

      function updateImageArea(img) {
        if (!hasImageAreaChanged(img)) {
          return
        }
        let cachedImageWidth = img.width;
        let cachedImageHeight = img.height;

        if (options.autoScaleForRetina) {
          canvas.width = cachedImageWidth * frontBackRatio
          canvas.height = (cachedImageHeight * frontBackRatio)

          //mobile_wrapper.height=cachedImageHeight * frontBackRatio
          g.scale(frontBackRatio, frontBackRatio)
        }
        else {
          canvas.width = cachedImageWidth
          canvas.height = cachedImageHeight

          //mobile_wrapper.height=cachedImageHeight
          //mobile_wrapper.width=cachedImageWidth
          //mobile_wrapper.classList.remove('rotated')
        }

        cssRotation += _global.rotator(cachedScreen.rotation, _global.screen.rotation);

        if (_global.screen.rotation == 90)
          canvas.style[_global.cssTransform] = 'rotate(' + -90 + 'deg)'
        else if (_global.screen.rotation == 270)
          canvas.style[_global.cssTransform] = 'rotate(' + 270 + 'deg)'
        else
          canvas.style[_global.cssTransform] = 'rotate(0deg)'

        cachedScreen.bounds.h = _global.screen.bounds.h;
        cachedScreen.bounds.w = _global.screen.bounds.w;
        cachedScreen.rotation = _global.screen.rotation;

        let canvasAspect;
        let incwidth = canvas.width * 1.03; //increase the width of the wrapper by 6%
        _global.canvasAspect = incwidth / canvas.height;

        if (isRotated()) {
          //mobile_wrapper.style[cssTransform] = 'rotate(' + 180 + 'deg)'
          // mobile_wrapper.width=cachedImageHeight
          // mobile_wrapper.classList.add('rotated')
        }

        // if (isRotated()) {
        //   _global.isScreenRotated = true;
        //   // canvasAspect = img.height / img.width;
        //   _global.element.classList.add('rotated');
        //   _global.element.parentElement.firstElementChild.classList.add('rotatedImg');
        // }
        // else {
        //   _global.isScreenRotated = false;
        //   // canvasAspect = img.width / img.height;
        //   _global.element.classList.remove('rotated')
        //   _global.element.parentElement.firstElementChild.classList.remove('rotatedImg')
        // }

        // if (alwaysUpright) {
        //   // If the screen image is always in upright position (but we
        //   // still want the rotation animation), we need to cancel out
        //   // the rotation by using another rotation.
        //   positioner.style[_global.cssTransform] = 'rotate(' + -cssRotation + 'deg)'
        // }

        const positionerEl = _global.element.closest('.positioner') as HTMLElement
          || _global.element.parentElement as HTMLElement;

        if (isRotated()) {
          _global.isScreenRotated = true;
          console.log("cssRotation:", _global.screen.rotation);

          _global.deviceService.setActive(true);
          let incHeight = canvas.height * 1.12; //increase the height of the wrapper by 6%
          let decWidth = canvas.width * 1.061; //decrease the width of the wrapper by 6%
          _global.canvasAspect = decWidth / incHeight;
          // store portrait dims so CSS can swap them for landscape
          // positionerEl.style.setProperty('--positioner-w', positionerEl.offsetWidth + 'px');
          // positionerEl.style.setProperty('--positioner-h', positionerEl.offsetHeight + 'px');
        } else {
          _global.isScreenRotated = false;
          _global.deviceService.setActive(false);
          // positionerEl.style.removeProperty('--positioner-w');
          // positionerEl.style.removeProperty('--positioner-h');
        }

        maybeFlipLetterbox();
      }

      return function messageListener(message: any) {
        _global.screen.rotation = _global.device.display.rotation;
        // if (message.data instanceof Blob) {
        //   _global.loader = false;
        //   _global.cursor = 'default';


        //   // FPS tracking - record frame timing
        //   const currentTime = performance.now();
        //   if (_global.lastFrameTime > 0) {
        //     const frameInterval = currentTime - _global.lastFrameTime;
        //     _global.frameTimeHistory.push(frameInterval);
        //     if (_global.frameTimeHistory.length > _global.FRAME_HISTORY_SIZE) {
        //       _global.frameTimeHistory.shift();
        //     }
        //     _global.frameCount++;

        //     if (_global.frameCount % 5 === 0) {
        //       monitorFPS();
        //     }
        //   }
        //   _global.lastFrameTime = currentTime;

        //   if (shouldUpdateScreen()) {
        //     if (_global.displayError) {
        //       // scope.$apply(function() {
        //       //   this.displayError = false
        //       // })
        //     }

        //     let blob = new Blob([message.data], {
        //       type: 'image/jpeg'
        //     })

        //     let img = imagePool.next()

        //     img.onload = () => {
        //       updateImageArea(img);

        //       g.drawImage(img, 0, 0, img.width, img.height)

        //       // Try to forcefully clean everything to get rid of memory
        //       // leaks. Note that despite this effort, Chrome will still
        //       // leak huge amounts of memory when the developer tools are
        //       // open, probably to save the resources for inspection. When
        //       // the developer tools are closed no memory is leaked.
        //       img.onload = img.onerror = null;
        //       img.src = _global.BLANK_IMG;
        //       img = null
        //       blob = null

        //       URL.revokeObjectURL(url)
        //       url = null
        //     }

        //     img.onerror = () => {
        //       // Happily ignore. I suppose this shouldn't happen, but
        //       // sometimes it does, presumably when we're loading images
        //       // too quickly.

        //       // Do the same cleanup here as in onload.
        //       img.onload = img.onerror = null
        //       img.src = _global.BLANK_IMG
        //       img = null
        //       blob = null

        //       URL.revokeObjectURL(url)
        //       url = null
        //     }

        //     let url = URL.createObjectURL(blob)
        //     img.src = url
        //   }
        // }
        //for decompression in FE
        if (message.data instanceof Blob) {
          _global.loader = false;
          _global.cursor = 'default';
          const reader = new FileReader();

          reader.onload = () => {
            const compressed = new Uint8Array(reader.result as ArrayBuffer);
            const decompressed = pako.ungzip(compressed);

            const blob = new Blob([decompressed], { type: 'image/jpeg' });

            const img = imagePool.next();
            img.onload = () => {
              updateImageArea(img);
              g.drawImage(img, 0, 0, img.width, img.height);
              // Cleanup...
            };
            img.onerror = () => {
              // Handle error and cleanup...
            };
            const url = URL.createObjectURL(blob);
            img.src = url;
          };

          reader.readAsArrayBuffer(message.data);
        }
        else if (/^start /.test(message.data)) {
          applyQuirks(JSON.parse(message.data.substr('start '.length)))
        }
        else if (message.data === 'secure_on') {
          // scope.$apply(function() {
          //   scope.displayError = 'secure'
          // })
        }
      }
    })();

    //Check this <------------------------------------------------------
    // scope.$on('fa-pane-resize', _.debounce(updateBounds, 1000))
    // scope.$watch('device.using', checkEnabled)
    // scope.$on('visibilitychange', checkEnabled)
    // scope.$watch('$parent.showScreen', checkEnabled)

    // scope.$on('guest-portrait', function () {
    //   control.rotate(0)
    // })

    // scope.$on('guest-landscape', function () {
    //   control.rotate(90)
    // })

    let canvasAspect = 1
    let parentAspect = 1

    function resizeListener() {
      parentAspect = _global.element.offsetWidth / _global.element.offsetHeight;
      maybeFlipLetterbox()
    }

    function maybeFlipLetterbox() {
      _global.element.classList.toggle(
        'letterboxed', parentAspect < canvasAspect)
    }
    // let ro = new ResizeObserver(entries => {
    //   let c = entries[0]
    //   let w = _global.element.parentElement.firstElementChild as HTMLElement;
    //   //let w = _global.element;

    //   if (this.isScreenRotated) {
    //     w.style.height = (c.contentRect.width + c.contentRect.width * 0.04) + 'px';
    //     w.style.width = (c.contentRect.height + c.contentRect.height * 0.13) + 'px';
    //   } else {
    //     w.style.width = (c.contentRect.width + c.contentRect.width * 0.13) + 'px';
    //     w.style.height = (c.contentRect.height + c.contentRect.height * 0.05) + 'px';
    //   }
    // });

    //Check this <------------------------------------------------------
    // ro.observe(canvas);
    window.addEventListener('resize', resizeListener, false)
    // scope.$on('fa-pane-resize', resizeListener)

    resizeListener();

    // Expose FPS data for debugging or UI display (optional)

    // You can remove this if not needed

    (this as any).getCurrentFPS = () => this.currentFPS;
    (this as any).getFPSHistory = () => this.frameTimeHistory.slice();

    // scope.$on('$destroy', function () {
    //   stop()
    //   $window.removeEventListener('resize', resizeListener, false)
    // })
  }

  resetLowFPSAlert(): void {
    this.isLowFPSAlertActive = false;
    this.lowFPSStartTime = 0;
  }

  // Method to show low FPS toast (Angular compatible)
  // showLowFPSToast(): void {
  //   const container = document.getElementById('toastContainer');
  //   if (!container) return;

  //   // Create toast element
  //   const toast = document.createElement('div');
  //   toast.className = 'toast';

  //   // Create unique ID for this toast
  //   const toastId = 'toast_' + Date.now();
  //   toast.id = toastId;

  //   toast.innerHTML = `
  //     <div class="toast-content">
  //       <div class="toast-icon-wrapper">
  //         <span class="toast-icon">⚠️</span>
  //       </div>
  //       <div class="toast-text">
  //         <div class="toast-title">Connection Issue</div>
  //         <div class="toast-message">Low frame rate detected due to network instability. Please check your internet connection.</div>
  //       </div>
  //     </div>
  //     <button class="toast-close" data-toast-id="${toastId}" aria-label="Close notification">
  //       <span class="toast-close-icon">&times;</span>
  //     </button>
  //   `;

  //   // Add click event listener for close button (Angular compatible)
  //   const closeButton = toast.querySelector('.toast-close') as HTMLButtonElement;
  //   closeButton.addEventListener('click', () => {
  //     this.closeToastById(toastId);
  //   });

  //   // Add toast to container
  //   container.appendChild(toast);

  //   // Trigger animation
  //   setTimeout(() => {
  //     toast.classList.add('show');
  //   }, 10);

  //   // Auto-remove after 8 seconds if not manually closed
  //   setTimeout(() => {
  //     this.closeToastById(toastId);
  //   }, 10000);
  // }
  showLowFPSToast(): void {
    const container = document.getElementById('toastContainer');
    if (!container) return;

    const toast = document.createElement('div');
    toast.className = 'toast';
    const toastId = 'toast_' + Date.now();
    toast.id = toastId;


    toast.innerHTML = `
       <div class="warning-container">
        <div title="Low frame rate detected due to network instability. Please check your internet connection." class="warning-icon">⚠️</div>
       </div>`;

    const closeButton = toast.querySelector('.toast-close') as HTMLButtonElement;
    closeButton.addEventListener('click', () => {
      this.closeToastById(toastId);
      this.resetLowFPSAlert(); // Now this works!
    });

    container.appendChild(toast);

    setTimeout(() => {
      toast.classList.add('show');
    }, 10);

    setTimeout(() => {
      this.closeToastById(toastId);
      this.resetLowFPSAlert(); // And this too!
    }, 10000);//10000
  }

  // Method to close toast by ID
  private closeToastById(toastId: string): void {
    const toast = document.getElementById(toastId);
    if (toast && toast.parentNode) {
      toast.classList.remove('show');

      // Remove element after animation
      setTimeout(() => {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 400);
    }
  }

  // Method to prevent duplicate toasts
  showLowFPSToastOnce(): void {
    const existingToast = document.querySelector('.toast');
    if (!existingToast) {
      this.showLowFPSToast();
    }
  }

  // Update your FPS alert trigger
  // private triggerLowFPSAlert(): void {
  //   this.showLowFPSToastOnce();
  // }

  retryLoadingScreen() {
    if (this.displayError === 'secure') {
      this.control.home('');
    }
  }

  /**
   * KEYBOARD HANDLING
   *
   * This should be moved elsewhere, but due to shared dependencies and
   * elements it's currently here. So basically due to laziness.
   *
   * For now, try to keep the whole section as a separate unit as much
   * as possible.
   */

  keyboardHandlingMethod() {
    let isChangeCharsetKey = (e: any) => {
      // Add any special key here for changing charset

      // Chrome/Safari/Opera
      if (
        // Mac | Kinesis keyboard | Karabiner | Latin key, Kana key
        e.keyCode === 0 && e.keyIdentifier === 'U+0010' ||

        // Mac | MacBook Pro keyboard | Latin key, Kana key
        e.keyCode === 0 && e.keyIdentifier === 'U+0020' ||

        // Win | Lenovo X230 keyboard | Alt+Latin key
        e.keyCode === 246 && e.keyIdentifier === 'U+00F6' ||

        // Win | Lenovo X230 keyboard | Convert key
        e.keyCode === 28 && e.keyIdentifier === 'U+001C'
      ) {
        return true
      }

      // Firefox
      switch (e.key) {
        case 'Convert': // Windows | Convert key
        case 'Alphanumeric': // Mac | Latin key
        case 'RomanCharacters': // Windows/Mac | Latin key
        case 'KanjiMode': // Windows/Mac | Kana key
          return true
      }

      return false
    }

    let handleSpecialKeys = (e: any) => {
      if (isChangeCharsetKey(e)) {
        e.preventDefault();
        this.control.keyPress('switch_charset');
        return true;
      }
      return false;
    }

    this.listeners['keydownListener'] = (e: any) => {
      // Prevent tab from switching focus to the next element, we only want
      // that to happen on the device side.      
      if (e.code == "ArrowLeft") {
        this.control.sendArrowKeys('input.keyDown', { 'key': "dpad_left" })
        this.control.sendArrowKeys('input.keyUp', { 'key': "dpad_left" })
      }
      if (e.code == "ArrowRight") {
        this.control.sendArrowKeys('input.keyDown', { 'key': "dpad_right" })
        this.control.sendArrowKeys('input.keyUp', { 'key': "dpad_right" })
      }
      if (e.code == "ArrowUp") {
        this.control.sendArrowKeys('input.keyDown', { 'key': "dpad_up" })
        this.control.sendArrowKeys('input.keyUp', { 'key': "dpad_up" })
      }
      if (e.code == "ArrowDown") {
        this.control.sendArrowKeys('input.keyDown', { 'key': "dpad_down" })
        this.control.sendArrowKeys('input.keyUp', { 'key': "dpad_down" })
      }
      if (e.code == "Enter") {
        this.control.sendEnter('input.keyDown', { 'key': "enter" })
        this.control.sendEnter('input.keyUp', { 'key': "enter" })
      }
      if (e.code == "Backspace") {
        this.control.sendBackspace('input.keyDown', { 'key': "del" });
        this.control.sendBackspace('input.keyUp', { 'key': "del" });
      }
      if (e.code == "Delete") {
        this.control.sendDelete('input.keyDown', { 'key': "forward_del" });
        this.control.sendDelete('input.keyUp', { 'key': "forward_del" });
      }
      if (e.keyCode === 9) {
        e.preventDefault();
      }
      this.control.keyDown(e.keyCode)
    }

    this.listeners['keyupListener'] = (e: any) => {
      if (!handleSpecialKeys(e)) {
        this.control.keyUp(e.keyCode);
      }
    }

    this.listeners['pasteListener'] = (e: any) => {
      // Prevent value change or the input event sees it. This way we get
      // the real value instead of any "\n" -> " " conversions we might see
      // in the input value.
      e.preventDefault();
      this.control.paste(e.clipboardData.getData('text/plain'))
    }

    this.listeners['copyListener'] = (e: any) => {
      e.preventDefault()
      // This is asynchronous and by the time it returns we will no longer
      // have access to setData(). In other words it doesn't work. Currently
      // what happens is that on the first copy, it will attempt to fetch
      // the clipboard contents. Only on the second copy will it actually
      // copy that to the clipboard.
      this.control.getClipboardContent();
      if (this.control.clipboardContent) {
        e.clipboardData.setData('text/plain', this.control.clipboardContent);
      }
    }

    this.listeners['inputListener'] = (e: any) => {
      // Why use the input event if we don't let it handle pasting? The
      // reason is that on latest Safari (Version 8.0 (10600.1.25)), if
      // you use the "Romaji" Kotoeri input method, we'll never get any
      // keypress events. It also causes us to lose the very first keypress
      // on the page. Currently I'm not sure if we can fix that one.
      //check this <-----------------------------------------------------
      this.control.sendKeyInput('input.type', e)


      // this.control.type(this.value);
      // this.value = ''
    }
    this.input.addEventListener('keydown', this.listeners['keydownListener']);
    this.input.addEventListener('keyup', this.listeners['keyupListener']);
    this.input.addEventListener('input', this.listeners['inputListener']);
    this.input.addEventListener('paste', this.listeners['pasteListener']);
    this.input.addEventListener('copy', this.listeners['copyListener']);


    // this.input.bind('keydown', keydownListener);
    // this.input.bind('keyup', keyupListener);
    // this.input.bind('input', inputListener);
    // this.input.bind('paste', pasteListener);
    // this.input.bind('copy', copyListener);
  }


  /**
   * TOUCH HANDLING
   *
   * This should be moved elsewhere, but due to shared dependencies and
   * elements it's currently here. So basically due to laziness.
   *
   * For now, try to keep the whole section as a separate unit as much
   * as possible.
   */

  touchHandlingMethod() {
    let transformCoordsForIosLandscape = (xP: number, yP: number): { xP: number, yP: number } => {
      if (this.device.ios !== true || !this.isScreenRotated) {
        return { xP, yP }; // no transform needed
      }
      // Canvas is rotated -90deg (rotation=90) or 270deg (rotation=270)
      // We need to swap and mirror coordinates to match physical touch space
      if (this.screen.rotation === 90) {
        // rotate touch coords 90deg clockwise to match physical screen
        return { xP: yP, yP: 1 - xP };
      } else if (this.screen.rotation === 270) {
        // rotate touch coords 90deg counter-clockwise
        return { xP: 1 - yP, yP: xP };
      }
      return { xP, yP };
    }
    //ios change
    // let prevCoords = {}
    //ios change
    let slots = [];
    let slotted = Object.create(null);
    let fingers = [];
    let seq = -1;
    let cycle = 100;
    let fakePinch = false;
    let lastPossiblyBuggyMouseUpEvent: any = 0;
    let longPressTimer: any = null;
    let longPressThreshold = 750; // milliseconds for long press
    let longPressMoveThreshold = 10; // pixels user can move while still triggering long press
    let initialTouchPosition: any = { x: 0, y: 0 };
    let longPressActive = false;
    let touchStartTime = 0;
    let currentTouchIdentifier: any = null;

    let nextSeq = () => {
      return ++seq >= cycle ? (seq = 0) : seq;
    }

    let createSlots = () => {
      // The reverse order is important because slots and fingers are in
      // opposite sort order. Anyway don't change anything here unless
      // you understand what it does and why.
      for (let i = 9; i >= 0; --i) {
        let finger = createFinger(i);
        this.element.append(finger);
        slots.push(i);
        fingers.unshift(finger);
      }
    }

    let activateFinger = (index: any, x: any, y: any, pressure: any) => {
      let scale = 0.5 + pressure
      fingers[index].classList.add('active')
      fingers[index].style[this.cssTransform] =
        'translate3d(' + x + 'px,' + y + 'px,0) ' +
        'scale(' + scale + ',' + scale + ')'
    }

    let deactivateFinger = (index: any) => {
      fingers[index].classList.remove('active')
    }

    let deactivateFingers = () => {
      for (let i = 0, l = fingers.length; i < l; ++i) {
        fingers[i].classList.remove('active')
      }
    }

    let createFinger = (index: any) => {
      let el = document.createElement('span')
      el.className = 'finger finger-' + index
      return el;
    }

    let calculateBounds = () => {

      let el = this.element as HTMLElement;

      this.screen.bounds.w = el.offsetWidth
      this.screen.bounds.h = el.offsetHeight
      this.screen.bounds.x = 0
      this.screen.bounds.y = 0

      while (el.offsetParent) {
        this.screen.bounds.x += el.offsetLeft
        this.screen.bounds.y += el.offsetTop
        el = el.offsetParent as HTMLElement;
      }
    }
    // Start long press timer
    let startLongPressTimer = (identifier: any, slot: any, x: number, y: number, pressure: number) => {
      clearLongPressTimer(); // Clear any existing timer

      initialTouchPosition = { x, y };
      touchStartTime = Date.now();
      currentTouchIdentifier = identifier;
      longPressActive = false;

      longPressTimer = setTimeout(() => {
        // Only trigger long press if touch hasn't moved much
        longPressActive = true;

        // iOS specific long press handling
        if (this.device.ios === true) {
          // Dispatch custom event for long press on iOS
          const longPressEvent = new CustomEvent('longpress', {
            detail: {
              identifier: identifier,
              slot: slot,
              x: x,
              y: y,
              pressure: pressure
            },
            bubbles: true,
            cancelable: true
          });
          this.element.dispatchEvent(longPressEvent);
        }
      }, longPressThreshold);
    }

    // Clear long press timer
    let clearLongPressTimer = () => {
      if (longPressTimer) {
        clearTimeout(longPressTimer);
        longPressTimer = null;
      }
      longPressActive = false;
    }

    // Check if the touch has moved beyond threshold
    let hasMovedBeyondThreshold = (currentX: number, currentY: number) => {
      const deltaX = Math.abs(currentX - initialTouchPosition.x);
      const deltaY = Math.abs(currentY - initialTouchPosition.y);
      return (deltaX > longPressMoveThreshold || deltaY > longPressMoveThreshold);
    }
    // Check if this is a long press
    let checkIsLongPress = (identifier: any) => {
      const touchDuration = Date.now() - touchStartTime;
      return identifier === currentTouchIdentifier &&
        touchDuration >= longPressThreshold &&
        longPressActive;
    }

    let mouseDownListener = (event: any) => {

      let e = event;
      if (e.originalEvent) {
        e = e.originalEvent
      }

      // Skip secondary click
      if (e.which === 3) {
        return
      }

      e.preventDefault()

      fakePinch = e.altKey

      calculateBounds()
      startMousing()

      let x = e.pageX - this.screen.bounds.x;
      let y = e.pageY - this.screen.bounds.y;
      let pressure = 0.5
      // let scaled = this.scaler.coords(
      //   this.screen.bounds.w
      //   , this.screen.bounds.h
      //   , x
      //   , y
      //   , this.screen.rotation
      // )
      //new
      let scaled = this.scaler.coords(
        this.screen.bounds.w, this.screen.bounds.h,
        x, y, this.screen.rotation
      )
      const transformedCoords = transformCoordsForIosLandscape(scaled.xP, scaled.yP); // ADD

      this.prevCoords = {
        x: transformedCoords.xP,  // CHANGED from scaled.xP
        y: transformedCoords.yP,  // CHANGED from scaled.yP
      }

      if (this.device.ios === true) {
        this.control.touchDownIos(nextSeq(), 0, transformedCoords.xP, transformedCoords.yP, pressure)  // CHANGED
        startLongPressTimer('mouse-0', 0, transformedCoords.xP, transformedCoords.yP, pressure);       // CHANGED
        if (fakePinch) {
          this.control.touchDownIos(nextSeq(), 1, 1 - transformedCoords.xP, 1 - transformedCoords.yP, pressure) // CHANGED
        }
      }
      //new
       else {
        this.control.touchDown(nextSeq(), 0, scaled.xP, scaled.yP, pressure)
        if (fakePinch) {
          this.control.touchDown(nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP, pressure)
        }
        this.abscissa = scaled.xP;
        this.ordinate = scaled.yP;
      }
      // ios change

      // this.control.touchDown(nextSeq(), 0, scaled.xP, scaled.yP, pressure);

      // if (fakePinch) {
      //   this.control.touchDown(nextSeq(), 1, 1 - scaled.xP, 1 - scaled.yP,
      //     pressure)
      // }

      this.control.touchCommit(nextSeq())

      activateFinger(0, x, y, pressure)

      if (fakePinch) {
        activateFinger(1, -e.pageX + this.screen.bounds.x + this.screen.bounds.w,
          -e.pageY + this.screen.bounds.y + this.screen.bounds.h, pressure);
      }

      this.element.addEventListener('mousemove', mouseMoveListener);
      this.element.addEventListener('mouseup', mouseUpListener);//this
      this.element.addEventListener('mouseleave', mouseUpListener);

      // this.renderer.listen(this.element, 'mousemove', mouseMoveListener);
      // this.renderer.listen(this.element, 'mouseup', mouseUpListener);
      // this.renderer.listen(this.element, 'mouseleave', mouseUpListener);
      // this.element.bind('mousemove', mouseMoveListener)
      // $document.bind('mouseup', mouseUpListener)
      // $document.bind('mouseleave', mouseUpListener)

      if (lastPossiblyBuggyMouseUpEvent &&
        lastPossiblyBuggyMouseUpEvent.timeStamp > e.timeStamp) {
        // We got mouseup before mousedown. See mouseUpBugWorkaroundListener
        // for details.
        mouseUpListener(lastPossiblyBuggyMouseUpEvent)
      }
      else {
        lastPossiblyBuggyMouseUpEvent = null
      }
    }

    let mouseMoveListener = (event: any) => {

      let e = event
      if (e.originalEvent) {
        e = e.originalEvent
      }

      // Skip secondary click
      if (e.which === 3) {
        return
      }
      e.preventDefault()

      let addGhostFinger = !fakePinch && e.altKey
      let deleteGhostFinger = fakePinch && !e.altKey

      fakePinch = e.altKey

      let x = e.pageX - this.screen.bounds.x
      let y = e.pageY - this.screen.bounds.y
      let pressure = 0.5
      // let scaled = this.scaler.coords(
      //   this.screen.bounds.w
      //   , this.screen.bounds.h
      //   , x
      //   , y
      //   , this.screen.rotation
      // )
      //new
      let scaled = this.scaler.coords(
        this.screen.bounds.w, this.screen.bounds.h,
        x, y, this.screen.rotation
      )
      const transformedCoords = transformCoordsForIosLandscape(scaled.xP, scaled.yP); // ADD

      if (this.device.ios === true && longPressTimer &&
        hasMovedBeyondThreshold(transformedCoords.xP, transformedCoords.yP)) { // CHANGED
        clearLongPressTimer();
      }
      this.control.touchMove(nextSeq(), 0, transformedCoords.xP, transformedCoords.yP, pressure) // CHANGED

      if (addGhostFinger) {
        if (this.device.ios === true) {
          this.control.touchDownIos(nextSeq(), 1, 1 - transformedCoords.xP, 1 - transformedCoords.yP, pressure) // CHANGED
        }
      } else if (fakePinch) {
        this.control.touchMove(nextSeq(), 1, 1 - transformedCoords.xP, 1 - transformedCoords.yP, pressure) // CHANGED
      }
      //new

      this.control.touchCommit(nextSeq())

      activateFinger(0, x, y, pressure)

      if (deleteGhostFinger) {
        deactivateFinger(1)
      }
      else if (fakePinch) {
        activateFinger(1, -e.pageX + this.screen.bounds.x + this.screen.bounds.w,
          -e.pageY + this.screen.bounds.y + this.screen.bounds.h, pressure);
      }
    }

    let mouseUpListener = (event: any) => {

      let e = event;
      if (e.originalEvent) {
        e = e.originalEvent
      }

      // Skip secondary click
      if (e.which === 3) {
        return
      }
      e.preventDefault()
      // Check if this is a long press
      const isLongPressActive = checkIsLongPress('mouse-0');
      // Clear long press timer on touch end
      if (!isLongPressActive) {
        clearLongPressTimer();
      }

      // Check if this is a legitimate touch up or if it's part of a long press
      const touchDuration = Date.now() - touchStartTime;
      // const isLongPress = touchDuration >= longPressThreshold && longPressActive;

      //ios change
      const x = e.pageX - this.screen.bounds.x
      const y = e.pageY - this.screen.bounds.y
      const pressure = 0.5
      // const scaled = this.scaler.coords(
      //   this.screen.bounds.w,
      //   this.screen.bounds.h,
      //   x,
      //   y,
      //   this.screen.rotation,
      //   this.device.ios,
      // )
      //new
      const scaled = this.scaler.coords(
        this.screen.bounds.w, this.screen.bounds.h,
        x, y, this.screen.rotation, this.device.ios,
      )
      const transformedCoords = transformCoordsForIosLandscape(scaled.xP, scaled.yP); // ADD

      const movedDuringPress =
        Math.abs(this.prevCoords.x - transformedCoords.xP) > 0.005 ||  // CHANGED
        Math.abs(this.prevCoords.y - transformedCoords.yP) > 0.005      // CHANGED

      if (this.device.ios && this.device.ios === true && (!isLongPressActive || movedDuringPress)) {
        this.control.touchMoveIos(
          transformedCoords.xP,   // CHANGED
          transformedCoords.yP,   // CHANGED
          this.prevCoords.x,
          this.prevCoords.y,
          pressure, nextSeq(), 0
        )
      }
      //new
      // Send the move if either: (a) it wasn't a long press (normal swipe/tap), or
      // (b) it was a long press but the finger actually moved -> press-and-drag gesture
      // (e.g. rearranging an iOS home-screen icon). The backend differentiates the two.
      // const movedDuringPress =
      //   Math.abs(this.prevCoords.x - scaled.xP) > 0.005 ||
      //   Math.abs(this.prevCoords.y - scaled.yP) > 0.005
      //ios change

      this.control.touchUp(nextSeq(), 0)

      if (fakePinch) {
        this.control.touchUp(nextSeq(), 1)
      }

      this.control.touchCommit(nextSeq())

      deactivateFinger(0)

      if (fakePinch) {
        deactivateFinger(1)
      }

      stopMousing()
    }

    /**
     * Do NOT remove under any circumstances. Currently, in the latest
     * Safari (Version 8.0 (10600.1.25)), if an input field is focused
     * while we do a tap click on an MBP trackpad ("Tap to click" in
     * Settings), it sometimes causes the mouseup event to trigger before
     * the mousedown event (but event.timeStamp will be correct). It
     * doesn't happen in any other browser. The following minimal test
     * case triggers the same behavior (although less frequently). Keep
     * tapping and you'll eventually see see two mouseups in a row with
     * the same counter value followed by a mousedown with a new counter
     * value. Also, when the bug happens, the cursor in the input field
     * stops blinking. It may take up to 300 attempts to spot the bug on
     * a MacBook Pro (Retina, 15-inch, Mid 2014).
     *
     *     <!doctype html>
     *
     *     <div id="touchable"
     *       style="width: 100px; height: 100px; background: green"></div>
     *     <input id="focusable" type="text" />
     *
     *     <script>
     *     let touchable = document.getElementById('touchable')
     *       , focusable = document.getElementById('focusable')
     *       , counter = 0
     *
     *     function mousedownListener(e) {
     *       counter += 1
     *       console.log('mousedown', counter, e, e.timeStamp)
     *       e.preventDefault()
     *     }
     *
     *     function mouseupListener(e) {
     *       e.preventDefault()
     *       console.log('mouseup', counter, e, e.timeStamp)
     *       focusable.focus()
     *     }
     *
     *     touchable.addEventListener('mousedown', mousedownListener, false)
     *     touchable.addEventListener('mouseup', mouseupListener, false)
     *     </script>
     *
     * I believe that the bug is caused by some kind of a race condition
     * in Safari. Using a textarea or a focused contenteditable does not
     * get rid of the bug. The bug also happens if the text field is
     * focused manually by the user (not with .focus()).
     *
     * It also doesn't help if you .blur() before .focus().
     *
     * So basically we'll just have to store the event on mouseup and check
     * if we should do the browser's job in the mousedown handler.
     */

    let mouseUpBugWorkaroundListener = (e: any) => {
      lastPossiblyBuggyMouseUpEvent = e
    }

    let startMousing = () => {
      this.control.gestureStart(nextSeq())
      this.input.focus()
    }

    let stopMousing = () => {
      this.element.removeEventListener('mousemove', mouseMoveListener);
      this.element.removeEventListener('mouseup', mouseUpListener);
      this.element.removeEventListener('mouseleave', mouseUpListener);
      // this.element.unbind('mousemove', mouseMoveListener)
      // $document.unbind('mouseup', mouseUpListener)
      // $document.unbind('mouseleave', mouseUpListener)
      deactivateFingers()
      this.control.gestureStop(nextSeq())
    }

    let touchStartListener = (event: any) => {

      let e = event;
      e.preventDefault()

      //Make it jQuery compatible also
      if (e.originalEvent) {
        e = e.originalEvent
      }

      calculateBounds()

      if (e.touches.length === e.changedTouches.length) {
        startTouching()
      }

      let currentTouches = Object.create(null)
      let i, l

      for (i = 0, l = e.touches.length; i < l; ++i) {
        currentTouches[e.touches[i].identifier] = 1
      }

      let maybeLostTouchEnd = (id: any) => {
        return !(id in currentTouches)
      }

      // We might have lost a touchend event due to various edge cases
      // (literally) such as dragging from the bottom of the screen so that
      // the control center appears. If so, let's ask for a reset.
      if (Object.keys(slotted).some(maybeLostTouchEnd)) {
        Object.keys(slotted).forEach((id) => {
          slots.push(slotted[id])
          delete slotted[id]
        });
        slots.sort().reverse();
        this.control.touchReset(nextSeq());
        deactivateFingers();
      }

      if (!slots.length) {
        // This should never happen but who knows...
        throw new Error('Ran out of multitouch slots')
      }

      for (i = 0, l = e.changedTouches.length; i < l; ++i) {
        let touch = e.changedTouches[i]
        let slot = slots.pop()
        let x = touch.pageX - this.screen.bounds.x
        let y = touch.pageY - this.screen.bounds.y
        this.abscissa = x;
        this.ordinate = y;
        let pressure = touch.force || 0.5
        // let scaled = this.scaler.coords(
        //   this.screen.bounds.w
        //   , this.screen.bounds.h
        //   , x
        //   , y
        //   , this.screen.rotation
        // )
        //new
        let scaled = this.scaler.coords(
          this.screen.bounds.w, this.screen.bounds.h,
          x, y, this.screen.rotation
        )
        const transformedCoords = transformCoordsForIosLandscape(scaled.xP, scaled.yP); // ADD

        if (this.device.ios === true) {
          this.control.touchDownIos(nextSeq(), slot, transformedCoords.xP, transformedCoords.yP, pressure) // CHANGED
          startLongPressTimer(touch.identifier, slot, transformedCoords.xP, transformedCoords.yP, pressure); // CHANGED
        } else {
          this.control.touchDown(nextSeq(), slot, scaled.xP, scaled.yP, pressure) // unchanged for Android
        }
        //new

        slotted[touch.identifier] = slot
        // this.control.touchDown(nextSeq(), slot, scaled.xP, scaled.yP, pressure)
        activateFinger(slot, x, y, pressure)
      }

      //listeners to be added to destroyFunctions array
      const touchMove = this.renderer.listen(this.element, 'touchmove', touchMoveListener.bind(this));
      const touchEnd = this.renderer.listen(this.element, 'touchend', touchEndListener);
      const touchleave = this.renderer.listen(this.element, 'touchleave', touchEndListener);
      this.destroyFunctions.push(
        touchMove,
        touchEnd,
        touchleave
      );
      // this.element.bind('touchmove', touchMoveListener)
      // $document.bind('touchend', touchEndListener)
      // $document.bind('touchleave', touchEndListener)

      this.control.touchCommit(nextSeq())
    }

    const touchMoveListener = (event) => {

      let e = event
      e.preventDefault()

      if (e.originalEvent) {
        e = e.originalEvent
      }

      for (let i = 0, l = e.changedTouches.length; i < l; ++i) {
        let touch = e.changedTouches[i]
        let slot = slotted[touch.identifier]
        let x = touch.pageX - this.screen.bounds.x
        let y = touch.pageY - this.screen.bounds.y
        let pressure = touch.force || 0.5
        // let scaled = this.scaler.coords(
        //   this.screen.bounds.w
        //   , this.screen.bounds.h
        //   , x
        //   , y
        //   , this.screen.rotation
        // )
        //new
        let scaled = this.scaler.coords(
          this.screen.bounds.w, this.screen.bounds.h,
          x, y, this.screen.rotation
        )
        const transformedCoords = transformCoordsForIosLandscape(scaled.xP, scaled.yP); // ADD

        if (this.device.ios === true &&
          touch.identifier === currentTouchIdentifier &&
          longPressTimer &&
          hasMovedBeyondThreshold(transformedCoords.xP, transformedCoords.yP)) { // CHANGED
          clearLongPressTimer();
        }

        // For iOS use transformed, for Android use original
        if (this.device.ios === true) {
          this.control.touchMove(nextSeq(), slot, transformedCoords.xP, transformedCoords.yP, pressure) // CHANGED
        } else {
          this.control.touchMove(nextSeq(), slot, scaled.xP, scaled.yP, pressure) // unchanged
        }
        //new
        activateFinger(slot, x, y, pressure)
      }

      this.control.touchCommit(nextSeq())
    }

    let touchEndListener = (event: any) => {
      let e = event;
      if (e.originalEvent) {
        e = e.originalEvent
      }

      let foundAny = false

      for (let i = 0, l = e.changedTouches.length; i < l; ++i) {
        let touch = e.changedTouches[i]
        let slot = slotted[touch.identifier]
        if (typeof slot === 'undefined') {
          // We've already disposed of the contact. We may have gotten a
          // touchend event for the same contact twice.
          continue
        }
        // Check if this is a long press using the helper function
        const isLongPressActive = checkIsLongPress(touch.identifier);

        // Only proceed with normal touch up if not in a long press state
        if (!isLongPressActive) {
          // Clear long press timer if not already triggered
          clearLongPressTimer();

          delete slotted[touch.identifier]
          slots.push(slot)
          this.control.touchUp(nextSeq(), slot)
          deactivateFinger(slot)
          foundAny = true
        }
      }

      if (foundAny) {
        this.control.touchCommit(nextSeq())
        if (!e.touches.length) {
          stopTouching()
        }
      }
    }

    let startTouching = () => {
      this.control.gestureStart(nextSeq())
    }

    let stopTouching = () => {
      this.element.removeEventListener('touchmove', touchMoveListener);
      this.element.removeEventListener('touchend', touchEndListener);
      this.element.removeEventListener('touchleave', touchEndListener);
      // this.element.unbind('touchmove', touchMoveListener)
      // $document.unbind('touchend', touchEndListener)
      // $document.unbind('touchleave', touchEndListener)
      deactivateFingers()
      this.control.gestureStop(nextSeq())
      // Make sure to clear long press timer when stopping
      clearLongPressTimer();
    }

    //listeners to be added to destroyFunctions array
    const touchStart = this.renderer.listen(this.element, 'touchstart', touchStartListener);
    const mouseDown = this.renderer.listen(this.element, 'mousedown', mouseDownListener);//this
    const mouseUpBug = this.renderer.listen(this.element, 'mouseup', mouseUpBugWorkaroundListener);
    this.destroyFunctions.push(
      touchStart,
      mouseDown,
      mouseUpBug
    )
    // this.element.on('touchstart', touchStartListener)
    // this.element.on('mousedown', mouseDownListener)
    // this.element.on('mouseup', mouseUpBugWorkaroundListener)

    createSlots()
  }

  getTopPosition(): string {
    return this.device.platform == 'iOS' ? '-3vh' : '-7vh';
  }



  // startRecording() {
  //   console.log(this.recordedChunks, "video data");
  //   this.receivedValue = null;
  //   this.recordedChunks = [];
  //   this.recordinngDate = new Date().toLocaleString();

  //   const canvas = this.canvasRef.nativeElement;
  //   const stream = canvas.captureStream(30); // 30 FPS

  //   if (!stream) {
  //     console.error("Stream capture failed");
  //     return;
  //   }

  //   // *Ensure Canvas Updates Continuously*
  //   const ctx = canvas.getContext("2d");
  //   const updateCanvas = () => {
  //     ctx.fillStyle = "rgba(255, 255, 255, 0.01)"; // Slight transparency
  //     ctx.fillRect(0, 0, canvas.width, canvas.height);
  //     requestAnimationFrame(updateCanvas);
  //   };
  //   updateCanvas(); // Start animation loop

  //   this.mediaRecorder = new MediaRecorder(stream);

  //   this.mediaRecorder.ondataavailable = (event) => {
  //     if (event.data.size > 0) {
  //       this.recordedChunks.push(event.data);
  //     }
  //   };

  //   this.mediaRecorder.onstop = () => {
  //     const blob = new Blob(this.recordedChunks, { type: "video/webm" });
  //     const url = URL.createObjectURL(blob);
  //     const currentDate = new Date().toLocaleString();
  //     console.log(url, "myurl");

  //     this.videoService.addVideoRecord(url, currentDate, this.device.serial);
  //     this.recordedChunks = [];
  //   };

  //   this.recordedChunks = [];
  //   this.mediaRecorder.start();
  // }

  startRecording() {
    this.videoService.setRecordingState(true);
    this.receivedValue = null
    this.recordedChunks = [];
    this.recordinngDate = new Date().toLocaleString()
    const stream = this.canvasRef.nativeElement.captureStream(30);
    if (!stream) {
      console.error('Stream capture failed');
      return;
    }
    //manualyy called beacause of blank save video
    const ctx = this.canvasRef.nativeElement.getContext("2d");
    ctx.fillStyle = "rgba(255, 255, 255, 0.01)"; // Slight transparency
    ctx.fillRect(0, 0, this.canvasRef.nativeElement.width, this.canvasRef.nativeElement.height);

    this.mediaRecorder = new MediaRecorder(stream);

    this.mediaRecorder.ondataavailable = (event) => {
      if (event.data.size > 0) {
        this.recordedChunks.push(event.data);
      }
    };


    this.mediaRecorder.onstop = () => {
      const blob = new Blob(this.recordedChunks, { type: 'video/webm' });
      const url = URL.createObjectURL(blob);
      const currentDate = new Date().toLocaleString();
      this.videoService.addVideoRecord(url, currentDate, this.device.serial);
      this.recordedChunks = [];
      // for download
      // const blob = new Blob(this.recordedChunks, { type: 'video/webm' });
      // const url = URL.createObjectURL(blob);
      // this.downloadVideo(url);
    };
    this.recordedChunks = [];
    this.mediaRecorder.start();




  }
  pauseRecording() {
    if (this.mediaRecorder.state === 'recording') {
      this.mediaRecorder.pause();
    }
  }

  resumeRecording() {
    if (this.mediaRecorder.state === 'paused') {
      this.mediaRecorder.resume();
    }
  }
  // stopRecording() {


  //   this.mediaRecorder.stop();
  // //   if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
  // //   // Wait for any pending data before stopping
  // //   setTimeout(() => {
  // //     this.mediaRecorder.stop();
  // //     console.log('Recording stopped');
  // //   }, 100);
  // // } else {
  // //   console.error('No active recording to stop');
  // // }
  // }



  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete(); // Clean up the subscription
    this.canvaslisteners.forEach(unlisten => unlisten());
  }

  stopRecording() {
    this.videoService.setRecordingState(false);
    if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
      this.mediaRecorder.stop();
    } else {
      console.log("No active recording to stop");
    }
  }
}